var render = function render(){var _vm=this,_c=_vm._self._c;return _c('direction-light',{attrs:{"position":_vm.sun,"hex":_vm.hex,"intensity":_vm.intensity}})
}
var staticRenderFns = []

export { render, staticRenderFns }